<template>
  <div>
    <div class="nav-header">
      <van-nav-bar :title="infoObj.title" left-arrow @click-left="leftFn" />
    </div>
    <div class="introduction" v-html="introduction"></div>
    <div class="footer-warp">
      <van-button round @click="buyAtOnce">立即购买￥{{ price }}</van-button>
    </div>
  </div>
</template>

<script>
import { courseView } from "@/api/parent-course";
export default {
  data() {
    return {
      infoObj: {},
      introduction: "",
      price: 0,
    };
  },

  // 计算属性
  computed: {},

  // 数据监听
  watch: {},

  // 自定义方法
  methods: {
    leftFn() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
    changeUrl(content) {
      return content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        (mactch, capture) => {
          let current = capture.slice(capture.indexOf("/business"));
          return mactch.replace(
            /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
            "src=" + current
          );
        }
      );
    },
    courseView() {
      const id = this.$route.params.id;
      courseView(id).then((res) => {
        this.infoObj = res.data;
        this.introduction = res.data.introduction;
        this.price = res.data.price;
      });
    },
    buyAtOnce() {
      //普通课程需要付费且没支付的 或者线下课程（因为线下课程可以无数次购买）
      if (
        (!this.infoObj.isFree && !this.infoObj.isPay) ||
        (this.infoObj.courseType && this.infoObj.courseType == 2)
      ) {
        localStorage.setItem("adress", "");
        sessionStorage.setItem("orderDetails", JSON.stringify(this.infoObj));
        if (this.infoObj.courseType && this.infoObj.courseType == 2) {
          //true 线下课程 false 线上课程
          this.$router.push("/outlineOrderConfirm");
        } else {
          this.$router.push("/orderConfirm");
        }
      }
    },
  },

  // 刚创建vue实例完毕
  created() {
    this.courseView();
  },

  // 刚挂载完毕
  mounted() {},
};
</script>
<style lang="scss" scoped>
.nav-header {
  .van-nav-bar {
    position: fixed;
    top: 0;
    width: 100%;
    ::v-deep .van-nav-bar__title {
      color: #161515;
      font-size: 18px;
      font-weight: 500;
    }
    ::v-deep .van-nav-bar__arrow {
      font-size: 18px;
    }
  }
}
.introduction {
  margin-top: 45px;
}
.footer-warp {
  position: fixed;
  padding: 0 20px;
  bottom: 33px;
  width: 100%;
  // background-color: #fff;
  .van-button {
    width: 100%;
    height: 40px;
    color: #ffffff !important;
    font-size: 16px;
    border: none;
    background: var(--btn-backgruond-color);
  }
}
</style>
